import { uniqueId } from 'lodash';
import internalJobIcon from '../../images/links/rms/icon_internal_job.svg';
const module = 'RMS';

export default [
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_InternalVacancies',
    icon: internalJobIcon,
    url: '/rms/internal-jrposting',
    messageApi: null,
    sort: 17,
    onlySupervisor: false,
  },
];



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/config/links/rms.js
 **/